<script>
    import { onMount } from "svelte";
    import Router from "../../router.js";
    import InlineRadio from "../../components/inline-radio.svelte";
    import Card from "../components/card.svelte";
    import Message from "../components/message.svelte";
    import { AuthUser } from "../../store.js";
    import HelpIcon from "../components/helpIcon.svelte";
    import DataTable from "../../components/data-table.svelte";
    import Modal from "../components/modal.svelte";
    import wrappedFetch from "../../wrappedFetch.js";
    import { Classes, Groups } from "./store.js";
    import { IsAuthConfigValid } from "../import/store.js";

    export let mainConfig;
    export let errMsg = '';
    export const UpdateAdvanceGroup = () => {
        mainConfig.groupsConfig.supportRegGroups = mainConfig.groupsConfig.supportAdvanceGroups && advanceGroups != '' && (advanceGroups == 'Registration' || advanceGroups == 'Both');
        mainConfig.groupsConfig.supportSubjGroups  = mainConfig.groupsConfig.supportAdvanceGroups && advanceGroups != '' && (advanceGroups == 'Subject' || advanceGroups == 'Both');
    }

    let yesNoQuestions = [
        { label: "Yes", value: true },
        { label: "No", value: false },
    ];
    let format = /[ `!@#$%^&*()+\=\[\]{};':"\\|,.<>\/?~]/;
    let advanceGroups = '';
    let datatable;
    let classesOrGroups = [];
    let showModal = false;
    let isLoadingClasses = false;
    let isLinkedToMultiSync = false;

    let title = mainConfig.groupsConfig.providerId == 1 ? "Google" : "Microsoft";

    $: disable = !mainConfig.accountConfig.syncPupils || !mainConfig.groupsConfig.autoCreateGroups;

    const SelectAdvanceOptions = () => {
        if (mainConfig.groupsConfig.supportAdvanceGroups == false)
            advanceGroups = '';
        else if (mainConfig.groupsConfig.supportRegGroups == true && mainConfig.groupsConfig.supportSubjGroups == true)
            advanceGroups = 'Both';
        else if (mainConfig.groupsConfig.supportRegGroups == true)
            advanceGroups = 'Registration';
        else if(mainConfig.groupsConfig.supportSubjGroups == true)
            advanceGroups = 'Subject';
    }

    onMount(async () => {
        SelectAdvanceOptions();
        await IsSchoolInProvidersMultiSync();

        if (!mainConfig.groupsConfig.dfEId || mainConfig.groupsConfig.dfEId == '')
            mainConfig.groupsConfig.dfEId = $AuthUser.dfes;  
        
        if (!mainConfig.groupsConfig) {
            Router.route(`/app/export/${mainConfig.groupsConfig.providerId}/step2`, false);
        }

        if($Classes.length == 0 || $Groups.length == 0)
        {
            isLoadingClasses = true;

            let resp = await wrappedFetch(`/api/reports/GetClassAndGroupData`, {
                method: "post",
            });

            let data  = await resp.json();
            Classes.set(data.classes);
            Groups.set(data.groups);
        }

        isLoadingClasses = false;
    });

    const PreviewClassesOrGroups = async () => {    
        showModal = true;
    }

    const IsSchoolInProvidersMultiSync = async () => {
        // console.log($AuthUser.schoolId, mainConfig.groupsConfig.providerId)
        await wrappedFetch(
            `/api/multiSync/IsSchoolInProvidersMultiSync?schoolId=${$AuthUser.schoolId}&providerId=${mainConfig.groupsConfig.providerId}`, 
            { method: "get" })
            .then (async (resp) => {
                isLinkedToMultiSync = await resp.text();
            })
            .catch(() => {
                isLinkedToMultiSync = false;
            });
    }


    $:{
        if (advanceGroups == 'Subject')
            classesOrGroups = $Classes;
        else if (advanceGroups == 'Registration')  
            classesOrGroups = $Groups;
        else if (advanceGroups == 'Both')
            classesOrGroups = $Classes.concat($Groups);

        //classesOrGroups=classesOrGroups.filter(c=>c.totalPupil > 0)    
    }
    
    $: {
        mainConfig.groupsConfig.prependCode = mainConfig.groupsConfig.useDfe ? '' : mainConfig.groupsConfig.prependCode;
    }

</script>

{#if mainConfig.groupsConfig}


<Card>
    <div slot="header"> 
        <h3>Groups</h3>
    </div>
    <div slot="body">
        <div class="form-group">
            <label for="groups" style="display:block;">
                Create and maintain {#if mainConfig.groupsConfig.providerId == 1} 'basic' {/if} {title} {#if mainConfig.groupsConfig.providerId == 3} Security {/if} Groups?
                <HelpIcon message="This includes { mainConfig.groupsConfig.providerId == 1 ? '' : 'security'} groups for all staff, all pupils and year groups (if being synced)" />
            </label>
            <InlineRadio for="groups"
                name="create-google-groups" 
                options={yesNoQuestions}                 
                bind:value={mainConfig.groupsConfig.autoCreateGroups}
            />
        </div>
        {#if mainConfig.groupsConfig.providerId == 1}
        <div class="form-group">
            <label for="advanceGroups" 
                style="display:block;" 
                class="{ disable ? 'labeldisabled' : ''}">
                Create and maintain {title} Groups for classes?
                <!-- <HelpIcon message="Advance groups include groups for registration classes, subject classes or both." /> -->
            </label>
            <InlineRadio for="advanceGroups"
                name="create-advance-groups" 
                options={yesNoQuestions}                 
                bind:value={mainConfig.groupsConfig.supportAdvanceGroups}
                disabled={disable}
            />
        </div>
        <div class="form-group">
            <label for="advanceGroupOpt" style="display:block;" class="{mainConfig.groupsConfig.autoCreateGroups && mainConfig.groupsConfig.supportAdvanceGroups ? '' : 'labeldisabled'}">
                What type of class data would you like to use for these groups?
                <!-- <HelpIcon message="Advance groups include groups for registration classes, subject classes or both." /> -->
            </label>
            <InlineRadio for="advanceGroupOpt"
                name="advance-group-opt" 
                options={[
                    { label: "Registration classes", value: 'Registration' },
                    { label: "Subject classes", value: 'Subject' },
                    { label: "Both", value: 'Both' },
                ]}                 
                bind:value={advanceGroups}
                disabled={ disable || !mainConfig.groupsConfig.supportAdvanceGroups }
            />
            {#if advanceGroups != null && advanceGroups != ''}
            <button disabled={isLoadingClasses} class="btn btn-sm btn-grey" on:click={PreviewClassesOrGroups} >
                {#if isLoadingClasses}
                    <span class="spinner-border spinner-border-sm" />
                {:else}
                    Preview
                {/if}
            </button>
            {/if}
        </div>
        {/if}

        {#if mainConfig.groupsConfig.providerId == 3}
        <div class="form-group">
            <label for="advanceGroups" style="display:block;" class="{ mainConfig.groupsConfig.autoCreateGroups ? '' : 'labeldisabled'}">
                Create and maintain Microsoft O365 Groups?
                <HelpIcon message="O365 groups are normally used for collaboration within groups. Security groups are always created if groups are being synced." />
            </label>
            <InlineRadio for="advanceGroups"
                name="create-advance-groups" 
                options={yesNoQuestions}                 
                bind:value={mainConfig.groupsConfig.createO365Groups}
                disabled={!mainConfig.groupsConfig.autoCreateGroups}
            />
        </div>
        {/if}

        <div class="form-group">
            <label for="prependGroups" style="display:block;" class="{mainConfig.groupsConfig.autoCreateGroups ? '' : 'labeldisabled'}">Add a prefix to the group names? 
            {#if isLinkedToMultiSync}
            <HelpIcon message="We advise adding clearly recognisable prefixes to your group names if your school is a member of a MultiSync in order to make sure that the groups are distinguishable between schools. Without prefixes, groups with the same name will be combined." />
            {/if}
            </label>
            <InlineRadio id="prependGroups"
                name="prepend-group-with-DfE" 
                options={yesNoQuestions} 
                bind:value={mainConfig.groupsConfig.prependGroupsWithDfE}    
                disabled={!mainConfig.groupsConfig.autoCreateGroups}
            />
        </div>
        {#if mainConfig.groupsConfig.autoCreateGroups && mainConfig.groupsConfig.prependGroupsWithDfE}
        <div class="form-group">
            <label for="prependCode" style="display:block;">What prefix do you want to use?</label>
            <div class="form-check form-check-inline" >
                
                <label class="form-check-label" for='dfe'>
                    <input
                        id="dfe"
                        class="form-check-input"
                        type="radio"
                        value={true}
                        name="code" 
                        bind:group={mainConfig.groupsConfig.useDfe}      
                    />
                    Your school's DfE code ({mainConfig.groupsConfig.dfEId}) 
                </label>

                <label class="form-check-label" for='otherCode'>
                    <input
                        id="otherCode"
                        class="form-check-input"
                        type="radio"
                        value={false}
                        name="code" 
                        style="margin-left: 10px;"
                        bind:group={mainConfig.groupsConfig.useDfe}      
                    />
                    or enter another code
                    <input type='text' style="border:1px solid #c4cdd5" bind:value={mainConfig.groupsConfig.prependCode} />
                </label>
            </div>

            {#if mainConfig.groupsConfig.prependGroupsWithDfE && format.test(mainConfig.groupsConfig.prependCode)}
                <div class="alert alert-info mt-2" role="alert">
                    The code can not contain one or more special characters used. Only - and _ characters plus numbers and letters will be accepted.
                </div>
            {/if}
        </div>
        {/if}
    </div>
</Card>

<Modal {showModal} targetClass="preview" on:close={() => (showModal = false)} on:show={()=>datatable.adjust()}>
    <div slot="header"><h4>Preview {title} Groups</h4></div>
    <div slot="content">
        <DataTable DataLength={classesOrGroups.length} bind:this={datatable} isFixedHeight={true} message="There are currently no classes of this type being imported.">
            <thead>
                <tr>                    
                    <th>Class</th>                                 
                    {#if advanceGroups == 'Subject' || advanceGroups == 'Both'} <th>Subject</th>{/if}
                    <th>Pupils</th>
                </tr>
            </thead>
            <tbody>
                {#each classesOrGroups as classes}
                <tr>
                    <td>{classes.className || ''}</td>
                    {#if advanceGroups == 'Subject' || advanceGroups == 'Both'}  <td>{classes.subject || ''}</td>   {/if}                    
                    <td>{classes.totalPupil}</td>
                </tr>
                {/each}
            </tbody>
        </DataTable>            
    </div>
</Modal>
{/if}

{#if errMsg != ''}
    <div style="margin-top: 5px;">
        <span style="color:red;">{errMsg}</span>
    </div>
{/if}